// Geolocation 取得。失敗時はフォールバック地点（博多）を返す。

export interface Coords {
  lat: number;
  lon: number;
  source: 'gps' | 'fallback';
}

const FALLBACK_HAKATA: Coords = { lat: 33.604, lon: 130.411, source: 'fallback' };

export async function getCurrentLocation(timeoutMs = 7000): Promise<Coords> {
  if (!('geolocation' in navigator)) return FALLBACK_HAKATA;
  return new Promise<Coords>((resolve) => {
    const timer = setTimeout(() => resolve(FALLBACK_HAKATA), timeoutMs);
    navigator.geolocation.getCurrentPosition(
      (pos) => {
        clearTimeout(timer);
        resolve({ lat: pos.coords.latitude, lon: pos.coords.longitude, source: 'gps' });
      },
      () => {
        clearTimeout(timer);
        resolve(FALLBACK_HAKATA);
      },
      { enableHighAccuracy: false, maximumAge: 5 * 60 * 1000, timeout: timeoutMs },
    );
  });
}
